import PropTypes from 'prop-types';
import queryString from 'query-string';
import React from 'react';
import reactT from '../reactT';

// Renders plain text input and submit button for text search.
// Rendered when env config autocomplete is not present or set to false.
// @see /env.local.js.example
class FederatedTextSearchNoAutocomplete extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      value: '',
    };

    this.handleInputChange = this.handleInputChange.bind(this);
    this.handleInputKeyDown = this.handleInputKeyDown.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    this.setState({
      value: nextProps.value,
    });
  }

  handleInputChange(ev) {
    this.setState({
      value: ev.target.value,
    });
  }

  handleInputKeyDown(ev) {
    if (ev.keyCode === 13) {
      this.handleSubmit();
    }
  }

  handleSubmit() {
    this.props.onChange(this.props.field, this.state.value);
    // Get existing querystring params.
    const parsed = queryString.parse(window.location.search);
    // Update the search querystring param with the value from the search field.
    parsed.search = this.state.value;
    const stringified = queryString.stringify(parsed);
    // Update the querystring params in the browser, add path to history.
    // See: https://developer.mozilla.org/en-US/docs/Web/API/History_API#The_pushState()_method
    if (window.history.pushState) {
      const newUrl = `${window.location.protocol}//${window.location.host}${window.location.pathname}?${stringified}`;
      window.history.pushState({ path: newUrl }, '', newUrl);
    } else {
      window.location.search = stringified;
    }
  }

  render() {
    const { label } = this.props;

    let placeholder = reactT('Search');
    let search_type = '';
    if (typeof drupalSettings !== 'undefined') {
      search_type = drupalSettings.type;
      /*global drupalSettings:true*/
      switch (search_type) {
        case 'publication':
          placeholder = reactT('Find publications');
          break;
        case 'event':
          placeholder = reactT('Find events');
          break;
        case 'news':
          placeholder = reactT('Find news');
          break;
        case 'supporters':
          placeholder = reactT('Find prominent supporters');
          break;
      }
    }

    return (
      <React.Fragment>
        <label htmlFor="search" className="search-form__label">{label}</label>
        <div className="form-item-keywords">
          <input
            type="search"
            name="search"
            id="search"
            className="form-control"
            autoFocus
            onChange={this.handleInputChange}
            onKeyDown={this.handleInputKeyDown}
            value={this.state.value || ''}
            placeholder={placeholder}
          />
          <a className="search-tips-btn d-none d-xl-flex" href="!#" onClick={(e) => e.preventDefault()} data-toggle="modal" data-target="#searchTips" rel="nofollow">{reactT('Search tips')}</a>
          <div className="form-actions">
            <button
              type="submit"
              className="button js-form-submit form-submit btn btn-primary"
              onClick={this.handleSubmit}>
              <span className="element-invisible">Perform Search</span>
            </button>
          </div>
        </div>
      </React.Fragment>
    );
  }
}

FederatedTextSearchNoAutocomplete.defaultProps = {
  label: '',
  onChange: () => {},
  value: '',
};

FederatedTextSearchNoAutocomplete.propTypes = {
  field: PropTypes.string.isRequired,
  label: PropTypes.string,
  onChange: PropTypes.func,
  value: PropTypes.string,
};

export default FederatedTextSearchNoAutocomplete;
